import { all, fork } from 'redux-saga/effects'
import * as physicianSaga from './physicianSaga';
import * as facilitySaga from './facilitySaga';
import * as patientSaga from './patientSaga';
import * as appointmentSaga from './appointmentSaga'
import * as servicesSaga from './servicesSaga'
import * as studySaga from './studySaga'

export default function * rootSaga () {
  yield all([
    ...Object.values(physicianSaga),
    ...Object.values(facilitySaga),
    ...Object.values(patientSaga),
    ...Object.values(appointmentSaga),
    ...Object.values(servicesSaga),
    ...Object.values(studySaga)
  ].map(fork))
}
